module.exports = __webpack_public_path__ + "static/media/Ferrothorn_gaussian2.f7801b73.png";